import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'; // Import environment variables
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseApiService {
  protected baseUrl: string = environment.API_ENDPOINT; // Base URL from environment

  constructor(protected http: HttpClient) {}

  protected headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  protected get<T>(endpoint: string, options?: any): Observable<any> {
    return this.http.get<T>(this.baseUrl + endpoint, {
      headers: this.headers,
      ...options,
    });
  }

  protected post<T>(endpoint: string, body: any, options?: any): Observable<any> {
    const headers = body instanceof FormData ? {} : this.headers; // Exclude headers if body is FormData

    return this.http.post<T>(this.baseUrl + endpoint, body, {
      headers: headers,
      ...options,
    });
  }

  protected put<T>(endpoint: string, body: any, options?: any): Observable<any> {
    return this.http.put<T>(this.baseUrl + endpoint, body, {
      headers: this.headers,
      ...options,
    });
  }

  protected delete<T>(endpoint: string, options?: any): Observable<any> {
    return this.http.delete<T>(this.baseUrl + endpoint, {
      headers: this.headers,
      ...options,
    });
  }

  protected httpRequest(
    method: string, // 'POST','PUT'
    endpoint: string,
    body: any,
    options?: any,
  ): Observable<any> {
    return this.http.request(method, this.baseUrl + endpoint, {
      body: body,
      ...options,
    });
  }
}
